// Panel collapsible di Build Mode untuk tambah sprite ke kanvas.

import { STRINGS } from '@tm/shared'
import { getSpriteLibraryKeys } from '../sandbox/assets.js'

export function mountSpritePicker({
  parent,
  initialSprites = [],
  onAdd,
  canvasCenter = { x: 360, y: 270 },
}) {
  const existing = parent.querySelector('.tm-sprite-picker')
  if (existing) existing.remove()

  const panel = document.createElement('aside')
  panel.className = 'tm-sprite-picker'
  panel.setAttribute('aria-label', STRINGS.spritePickerTitle)

  const spriteKeys = getSpriteLibraryKeys()
  const spriteCounts = initialSprites.reduce((acc, s) => {
    acc[s.key] = (acc[s.key] || 0) + 1
    return acc
  }, {})

  panel.innerHTML = `
    <button class="tm-sprite-picker__toggle" aria-expanded="false" aria-label="${STRINGS.spritePickerToggle}">
      ${STRINGS.spritePickerToggle}
    </button>
    <div class="tm-sprite-picker__body" hidden>
      <h3 class="tm-sprite-picker__title">${STRINGS.spritePickerTitle}</h3>
      <div class="tm-sprite-picker__grid" id="tm-sp-grid"></div>
    </div>
  `

  const grid = panel.querySelector('#tm-sp-grid')
  for (const key of spriteKeys) {
    const cell = document.createElement('button')
    cell.className = 'tm-sprite-picker__cell'
    cell.setAttribute('data-sprite-key', key)
    const count = spriteCounts[key] || 0
    const badge =
      count > 0
        ? `<span class="tm-sprite-picker__badge">${STRINGS.spritePickerBadge.replace('%d', count)}</span>`
        : ''
    cell.innerHTML = `
      <img src="/assets/sprites/${key}.svg" alt="${key}" />
      <span class="tm-sprite-picker__name">${key}</span>
      ${badge}
    `
    cell.addEventListener('click', () => showAddModal(key, onAdd, canvasCenter))
    grid.appendChild(cell)
  }

  const toggle = panel.querySelector('.tm-sprite-picker__toggle')
  const body = panel.querySelector('.tm-sprite-picker__body')
  toggle.addEventListener('click', () => {
    const isOpen = !body.hasAttribute('hidden')
    if (isOpen) {
      body.setAttribute('hidden', '')
      toggle.setAttribute('aria-expanded', 'false')
    } else {
      body.removeAttribute('hidden')
      toggle.setAttribute('aria-expanded', 'true')
    }
  })

  parent.appendChild(panel)
  return panel
}

function showAddModal(spriteKey, onAdd, canvasCenter) {
  const title = STRINGS.spritePickerAddTitle.replace('%s', spriteKey)
  const modal = document.createElement('div')
  modal.className = 'tm-modal-backdrop'
  modal.innerHTML = `
    <div class="tm-modal" role="dialog" aria-label="${title}">
      <h2>${title}</h2>
      <img src="/assets/sprites/${spriteKey}.svg" alt="" class="tm-modal__preview" />
      <label>
        ${STRINGS.spritePickerPosX}
        <input type="number" id="tm-modal-x" value="${canvasCenter.x}" />
      </label>
      <label>
        ${STRINGS.spritePickerPosY}
        <input type="number" id="tm-modal-y" value="${canvasCenter.y}" />
      </label>
      <div class="tm-modal__actions">
        <button data-action="center" class="tm-modal__btn-secondary">${STRINGS.spritePickerCenter}</button>
        <button data-action="cancel" class="tm-modal__btn-secondary">${STRINGS.spritePickerCancel}</button>
        <button data-action="confirm" class="tm-modal__btn-primary">${STRINGS.spritePickerConfirm}</button>
      </div>
    </div>
  `

  const xInput = modal.querySelector('#tm-modal-x')
  const yInput = modal.querySelector('#tm-modal-y')

  modal.querySelector('[data-action="center"]').addEventListener('click', () => {
    xInput.value = canvasCenter.x
    yInput.value = canvasCenter.y
  })

  modal.querySelector('[data-action="cancel"]').addEventListener('click', () => {
    modal.remove()
  })

  modal.querySelector('[data-action="confirm"]').addEventListener('click', () => {
    const x = Number(xInput.value) || canvasCenter.x
    const y = Number(yInput.value) || canvasCenter.y
    onAdd({ key: spriteKey, x, y })
    modal.remove()
  })

  document.body.appendChild(modal)
}
